import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'

const IdinformationForm = ({ navigation, route }: any): JSX.Element => {
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
  } = params
  const intializeStore = useInitializeStore()
  const { loading, postidonline } = useFormsStore()
  const personalstore = usePersonalStore()
  const options1 = [
    { key: 1, value: 'Single' },
    {
      key: 2,
      value:
        'Married'
    },
    {
      key: 3,
      value:
        'Married, but withhold at Single rate'
    },

  ]

  const intialValues = {
    withholdingstatus: '',
    totalnoofidahoallowances: null,
    claimadditional: null,
  }
  const w4schema = () => {
    const baseSchema = {
      withholdingstatus: yup.string().required('withholding status is a required field'),
      totalnoofidahoallowances: yup.string().nullable(),
      claimadditional: yup.string().nullable(),
    }


    return yup.object(baseSchema)
  }
  const schema = w4schema()

  const handlesubmit = async (values) => {
    const data = {
      essUserKey: intializeStore.initializeData?.userkey,
      entityId: personalstore.personalData?.entityId,
      essUserOnBoardingFormKey: essUserOnBoardingFormKey,
      essObKey: essUserOnBoardingKey,
      withholdingstatus: Number(values.withholdingstatus),
      totalnoofidahoallowances: Number(values.totalnoofidahoallowances),
      additionalamount: values?.claimadditional,
      completeOnline: mode == "online" ? true : false
    }


    const response: any = await postidonline(data)
    if (response?.success === true) {
      if (mode === 'online') {
        navigation.navigate('Idonline', {
          essUserOnBoardingKey,
          essUserOnBoardingFormKey,
          values,
          completeOnline: mode === 'upload' ? false : true
        })
      } else {
        await Toast.show({
          type: 'success',
          position: 'bottom',
          text1: response?.message,
          visibilityTime: 3000,
          autoHide: true,
          topOffset: 60,
          onHide: () => {
            navigation.replace('OnboardingForms')
          }
        })
      }
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'ID Withholding Taxation'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={schema}
          onSubmit={async (values, actions) => {
            await handlesubmit(values)
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '52%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Withholding Status*'}
                    </Text>
                  </View>
                  <View style={{ width: '35%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Withholding Status"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.withholdingstatus
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('withholdingstatus', option)
                      }}
                      textColor="primary"
                    />
                    {props.touched.withholdingstatus &&
                      props.errors.withholdingstatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.withholdingstatus}
                        </Text>
                      )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View
                    style={{ justifyContent: 'center', width: '50%' }}
                  >
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Total Number of Allowances'}
                    </Text>
                  </View>
                  <View style={{ width: '35%', overflow: 'hidden' }}>
                    <TextInput
                      style={[
                        globalStyles.input,
                        globalStyles.inputLight
                      ]}
                      value={props.values.totalnoofidahoallowances}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('totalnoofidahoallowances')(
                            text
                          )
                        }
                      }}
                    />
                    {props.touched.totalnoofidahoallowances &&
                      props.errors.totalnoofidahoallowances && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.totalnoofidahoallowances as string}
                        </Text>
                      )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View
                    style={{ justifyContent: 'center', width: '50%' }}
                  >
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Additional amount (if any) you need withheld from each paycheck '}
                    </Text>
                  </View>
                  <View style={{ width: '35%', overflow: 'hidden' }}>
                    <TextInput
                      style={[
                        globalStyles.input,
                        globalStyles.inputLight
                      ]}
                      value={props.values.claimadditional}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('claimadditional')(
                            text
                          )
                        }
                      }}
                    />
                    {props.touched.claimadditional &&
                      props.errors.claimadditional && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.claimadditional as string}
                        </Text>
                      )}
                  </View>
                </View>
                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>
            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}
export default IdinformationForm
